import React, { useState } from 'react'
import * as Yup from 'yup'
import { useSnackbar } from 'notistack'
import { useNavigate } from 'react-router-dom'
import { useCallback } from 'react'

import { Form, FormikProvider, useFormik } from 'formik'
import { Icon } from '@iconify/react'
import copyFill from '@iconify/icons-eva/copy-fill';
import { isAdminUser } from '../../../../utils/adminUserTypes';
import phoneCallFill from '@iconify/icons-eva/phone-call-fill'
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import { MIconButton } from 'src/components/@material-extend/index.js'
import { PATH_CALL } from 'src/routes/paths'
import { Block } from 'src/pages/components-overview/Block.js'
// import { Block } from '../Block';

// material
import {
  Box,
  Autocomplete,
  Checkbox,
  Button,
  Grid,
  Card,
  Stack,
  Switch,
  TextField,
  FormControlLabel,
  Typography,
  FormHelperText,
  Paper,
  Divider,
  Avatar,
  Rating,
  IconButton,
  InputAdornment,
  Tooltip,
  CardMedia,
  CardContent,
  CardHeader,
  CircularProgress,
  Radio,
  FormControl,
  RadioGroup,
  TablePagination,
  Chip,
} from '@material-ui/core'
import Label from 'src/components/Label.js'
import { Popover } from '@material-ui/core'
import { Details, Group as GroupIcon } from '@material-ui/icons'
import { Lock as LockIcon } from '@material-ui/icons'
import { ExpandMore, ExpandLess } from '@material-ui/icons'
import ThumbUpIcon from '@material-ui/icons/ThumbUp'
import ThumbDownIcon from '@material-ui/icons/ThumbDown'

import { LoadingButton } from '@material-ui/lab'
// hooks
import useAuth from '../../../../hooks/useAuth'
import useIsMountedRef from '../../../../hooks/useIsMountedRef'
import { UploadAvatar } from '../../../upload'
import { Link as RouterLink } from 'react-router-dom'
import { PATH_DASHBOARD } from 'src/routes/paths.js'
// utils
import { fData } from '../../../../utils/formatNumber'
//
import countries from '../countries'
import UserEdit from 'src/components/_dashboard/user/UserEdit.js'
import Request from 'src/components/_dashboard/user/profile/Request.js'
import Messages from 'src/components/_dashboard/user/profile/Messages.js'
import UserAccount from 'src/pages/dashboard/UserAccount.js'
import { experimentalStyled as styled } from '@material-ui/core/styles'
import Modal from 'src/components/_dashboard/blog/ProjectModel.js' // replace 'path/to/Modal' with the correct path to your Modal component
import User from 'src/redux/slices/user'
import { REST_API, REST_API_END_POINT } from 'src/constants/Defaultvalues'
import { status } from 'nprogress'
import axios from 'axios'
import { Text } from '@react-pdf/renderer'
import { useEffect } from 'react'
import { capitalCase } from 'change-case'
import ConfirmationPopup from '../../official-request/ConfirmationPopup'
import AttachmentDownloadIconButton from 'src/components/_dashboard/official-request/AttachmentDownloadIconButton'
import AttachmentPreviewDialog from 'src/components/_dashboard/official-request/AttachmentPreviewDialog'
import { downloadImage } from 'src/Helpers/FileDownloadUtils'
import LoadingScreen from 'src/components/LoadingScreen'
import CopyToClipboard from 'react-copy-to-clipboard'
import TagChip from '../../contact_tag/TagChip'
import PhoneNumberField from 'src/components/PhoneNumberField'
import LightboxModal from 'src/components/LightboxModal'
import LightboxModalTaxType from 'src/components/LightboxModalTaxType'
import { useTheme } from '@material-ui/core/styles'

// ----------------------------------------------------------------------

export default function AccountGeneral({
  clientTaxExemptAttachments,
  additionalEmails,
  setCurrentTab,
  userData,
  requests,
  services,
  states,
  teamServices,
  teamworkflows,
  receivedId,
  isTeam,
  isClient,
  clientId,
  clientDetails,
  allClientRequest,
  setRefreshData,
  refreshData,
  fetchViewClientData,
  clientworkFlow,
  driverData,
  isDriver,
  tags,
  setClientEdit,
  setClientId,
  setViewAccount
}) {
  const theme = useTheme()
  const navigate = useNavigate()
  const isMountedRef = useIsMountedRef()
  const { enqueueSnackbar } = useSnackbar()
  // const { user, updateProfile } = useAuth()
  const user = JSON.parse(localStorage.getItem('user'))

  console.log('userDatauserDatauserData', userData)
  console.log('userDatauserDatauserData', clientDetails)
  const [request, setRequest] = useState(false)
  const [popup, setPopup] = useState(false)
  const [group, setGroup] = useState(false)
  const [workflows, setWorkflows] = useState(false)
  const [deleteTeam, setDeleteTeam] = useState(false)
  const [openDeletePop,setOpenDeletePop] =useState(false)
  const [message, setMessage] = useState(false)
  const [isReviewFormOpen, setIsReviewFormOpen] = useState(false)
  const [liked, setLiked] = useState(false)
  const [disliked, setDisliked] = useState(false)
  const [internalNoteState, setInternalNote] = useState(false)
  const [teamRequest, setTeamRequest] = useState([])
  const [loading,setLoading] = useState(false);
 const  [password,setPassword] = useState({
  value:'',
  copied: false
 })
 const [customerTypeData,setCustomerTypeData] = useState([])
 const [userRoles, setUserRoles] = useState([]);
  const [images, setImages] = useState([]);
  const [pdfs, setPdfs] = useState([]);
  console.log('imagesimagesimages', images)
  console.log('pdfspdfspdfs', pdfs)
  const [imagePage, setImagePage] = useState(0);
  const [imageRowsPerPage, setImageRowsPerPage] = useState(3);
  const [pdfPage, setPdfPage] = useState(0);
  const [pdfRowsPerPage, setPdfRowsPerPage] = useState(3);
  const allClientAttachments = Array.isArray(clientTaxExemptAttachments) ? clientTaxExemptAttachments : [];
  const getAttachmentType = (attachment) => attachment?.attachment_type || 'tax_exempt';
  const taxExemptAttachments = allClientAttachments.filter(
    (attachment) => getAttachmentType(attachment) === 'tax_exempt'
  );
  const insuranceAttachments = allClientAttachments.filter(
    (attachment) => getAttachmentType(attachment) === 'insurance'
  );
  const otherFormAttachments = allClientAttachments.filter(
    (attachment) => getAttachmentType(attachment) === 'other_form'
  );
  const taxExemptDocuments = taxExemptAttachments.filter(
    (attachment) => !attachment.file_type?.startsWith('image') && attachment.file_type !== 'application/pdf'
  );
  const [openLightbox, setOpenLightbox] = useState(false);
  const [selectedImage, setSelectedImage] = useState(0);
  const [attachmentPreviewOpen, setAttachmentPreviewOpen] = useState(false);
  const [previewAttachment, setPreviewAttachment] = useState(null);
  const [previewPdfLoading, setPreviewPdfLoading] = useState(true);
  const [previewUseOfficeViewer, setPreviewUseOfficeViewer] = useState(true);
  const [userPin, setUserPin] = useState('');
 
 const userIsClient = user?.isClient
 let userType = userIsClient ? 3 : user?.user_type;
  // Hide download only for logged-in client users — not because this page is a client profile
  const viewerIsClient = Boolean(userIsClient || userType === 3);
  const canDownloadFiles = !viewerIsClient;
  // console.log('userTypeisTeam', userType,isTeam)
  // console.log('isClient - ', isClient)
  let deleteStatus = 2
  let workflowIds
  let namesArray
  let workflowArray
  let idsArray
  let requestIdsArray
  let requestsArray
  const fetchUserPin = async () => {
    try {
      const userId = isTeam
        ? userData?.user_id
        : isClient
          ? clientDetails?.user_id
          : isDriver
            ? driverData?.user_id
            : null;
      if (userId) {
        const result = await axios.post(`${REST_API_END_POINT}get-user-pin`, { userId });
        if (result.data.status === 1) {
          setUserPin(result.data.pin || '');
        }
      }
    } catch (error) {
      console.error('Error fetching PIN:', error);
    }
  };

  useEffect(() => {
    setLoading(true);
    try{
      fetchAllUserRole()
      // fetchData(receivedId)
      fetchAllCustomerTypeData()
    }
    catch(error){
      console.log(error);
    }
    finally{
      setTimeout(function () {
        setLoading(false);
      }, 1000)
    }
  }, [receivedId])

  useEffect(() => {
    if ((isTeam && userData?.user_id) || (isClient && clientDetails?.user_id)) {
      fetchUserPin()
    }
  }, [userData?.user_id, clientDetails?.user_id, isTeam, isClient])


   const fetchAllUserRole = async()=>{
     try {
     const response = await axios.post(`${REST_API_END_POINT}teams/get-user-roles`,{isClientUserRole:true});
       setUserRoles(response?.data?.result);
     } catch (error) {
       console.log("error",error)
     }
   }

  const fetchData = async (receivedId) => {
    if(isTeam || isClient ==false){
    axios
      .post(`${REST_API_END_POINT}teams/get-requests`, { teamId: receivedId })
      .then((response) => {
        
        setTeamRequest(response.data)
      })
    }
  }

  const fetchAllCustomerTypeData = async()=>{
    const response = await axios.post(`${REST_API_END_POINT}customer-type/get-customer-type`,{id:clientDetails?.customerTypeId})
    if(response.data.status==1){
      setCustomerTypeData(response.data.result)
      console.log('resulttttttttt',response.data.result)
    }else{
      setCustomerTypeData([])
    }
  }

  /***************************************************************************************************************************/
  //filter out the already added workflows

  if (isTeam) {
    if (userData.workflows) {
      workflowIds = userData.workflows
      
      idsArray = workflowIds.split(',') //split the workflow ids received from database
      workflowArray = teamworkflows.filter(
        (obj) => !idsArray.includes(obj.id.toString()),
      )
      namesArray = idsArray.map((id) => {
        const matchingObject = teamworkflows.find(
          (obj) => obj.id === parseInt(id, 10),
        )
        // return matchingObject ? matchingObject.name : 'Unknown'
        return matchingObject ? matchingObject:""
      })
    } 
  }else{
     if(clientDetails){
        workflowIds = clientDetails?.workflows
       
        idsArray = workflowIds?.split(',') 
        workflowArray = clientworkFlow?.filter(
          (obj) => !idsArray?.includes(obj.id.toString()),
        )
        namesArray = idsArray?.map((id) => {        
          const matchingObject = clientworkFlow?.find(
            (obj) => obj.id === parseInt(id, 10),
          )
          // return matchingObject ? matchingObject.name : 'Unknown'
          return matchingObject ? matchingObject:""
        })
      }
  }
 
  /***************************************************************************************************************************/
  //filter out the already added requests

  if (isTeam) {
    if (requests && requests.length > 0) {
      requestIdsArray = requests.map((item) => item.id.toString())
      requestsArray = teamRequest.filter(
        (obj) => !requestIdsArray.includes(obj.id.toString()),
      )
    } else {
      requestsArray = teamRequest.slice() 
    }
    
  }
  /***************************************************************************************************************************/
  //get user logged in data from local storage

  const userd = localStorage.getItem('user')
  const userDataSession = JSON.parse(userd)
  let userId = userDataSession.user_id
  let explodedPermissions = userDataSession?.exploded_permissions
  const hasSwitchUserPinPermission = explodedPermissions?.some(permission => ['Switch User With Pin'].includes(permission)) ? true : false

  const handleLike = () => {
    if (disliked) {
      setDisliked(false)
    }
    setLiked(!liked)
  }

  const handleDislike = () => {
    if (liked) {
      setLiked(false)
    }
    setDisliked(!disliked)
  }

  const readOnlyRating = 3
  // const [currentTab, setCurrentTab] = useState('Messages'); // Declare the currentTab state here

  const LabelStyle = styled(Typography)(({ theme }) => ({
    ...theme.typography.subtitle2,
    // color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
  }))

  const UpdateUserSchema = Yup.object().shape({
    about: Yup.string()
      .max(100, 'Internal note cannot exceed 100 characters')
      .nullable(),
        vendorNotes: Yup.string()
    .max(100, 'Notes cannot exceed 100 characters')
    .nullable(),
  })

  const [popoverAnchor, setPopoverAnchor] = useState(null)

  const openPopover = (event) => {
    setPopoverAnchor(event.currentTarget)
  }

  const closePopover = () => {
    setPopoverAnchor(null)
  }

  const Workflow = [
    { code: 'AD', label: 'Eli White' },
    { code: 'AE', label: 'John Manager' },
    { code: 'AF', label: 'Installer' },
    { code: 'AG', label: 'Install Coordinator' },
    { code: 'AI', label: 'Printer All' },
    { code: 'AL', label: 'Fab Cnc' },
    { code: 'AM', label: 'Fabricator Welder' },
    { code: 'AO', label: 'Fabricator Cutting And Sending' },
    { code: 'AQ', label: 'Painter Prep' },
    { code: 'AR', label: 'Quality Check Wrap' },
  ] // replace with your workflow data

  const Request = [
    { code: 'AD', label: 'Begin Production' },
    { code: 'AE', label: 'New Quotation' },
    { code: 'AF', label: 'Request 1' },
    { code: 'AG', label: 'Signboard A' },
    { code: 'AI', label: 'Sign Request Form' },
    { code: 'AL', label: 'Request 2' },
  ] // replace with your Request data

  const Group = [
    { code: 'AD', label: 'Admin' },
    { code: 'AE', label: 'Production' },
    { code: 'AF', label: 'Design' },
    { code: 'AG', label: 'Sales' },
  ] // replace with your Request data
  console.log('userData--userData==',userData);
  let defaultServicesArray=null
  if(userData?.services && isTeam){
    const serviceIds = (userData?.services?.includes(',')) ? (userData?.services?.split(',').map((id) => parseInt(id))) : [parseInt(userData?.services)];
    defaultServicesArray = serviceIds?.map((serviceId) => services?.find((d) => d.id === serviceId) || null);
    console.log('services==serviceIds==',serviceIds);
    console.log('services==services==',services);
    console.log('services==defaultServicesArray==',defaultServicesArray);
  }


// profile_photo
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      displayName:
        (isTeam && `${userData?.first_name} ${userData?.last_name}`) ||
        (isClient && clientDetails?.name) || ( isDriver && driverData?.name)|| '',
      email: (isTeam && userData?.email) || (isClient && clientDetails?.email) || ( isDriver && driverData?.email)|| '',
      photoURL: (isTeam && userData?.profile_pic) || (isClient && clientDetails?.profile_pic) || ( isDriver && driverData?.profile_photo)||'',
      phoneNumber: (isTeam && userData?.phone) || (isClient && clientDetails?.phone) || ( isDriver && driverData?.phone)|| '',
      phone_country_code: (isTeam   && userData?.phone_country_code) ||(isClient && clientDetails?.phone_country_code) ||(isDriver && driverData?.phone_country_code)|| '1',
      phone_extension: (isTeam && userData?.phone_extension) || (isClient && clientDetails?.phone_extension) || null,
      forward_no: (isTeam && userData?.forward_no) || '',
      forward_country_code: (isTeam   && userData?.forward_country_code) ||'1',
      hourlyRate: (isTeam && userData?.hourly_rate) || '',
      departmentName: (isTeam && userData?.department_name) || '',
      state: (isTeam && userData?.state) || (isClient && clientDetails?.state) || '',
      city: (isTeam && userData?.city) || (isClient && clientDetails?.city) || '',
      zipCode: (isClient && clientDetails?.zip_code) || '',
      country: (isClient && (countries.find(c => c.code === clientDetails?.country_short_name)?.label || clientDetails?.country_name)) || (isTeam && userData?.country_name) || (isDriver && driverData?.country_name) || '',
      about: (isTeam && userData?.internal_note) ||(isClient && clientDetails?.internal_note)|| '',
      service: isTeam && defaultServicesArray || [],
      // role: isTeam && userData?.user_role || '',
      clientRequestcheckbox: null,
      clients:[clientDetails],
      address:(isDriver && driverData?.address)|| (isClient && clientDetails?.address) ||
        '',
      remitToAddress: (isClient && clientDetails?.isVendor && clientDetails?.remit_to_address) || '',
      remitToCity: (isClient && clientDetails?.isVendor && clientDetails?.remit_to_city) || '',
      remitToZipCode: (isClient && clientDetails?.isVendor && clientDetails?.remit_to_zip_code) || '',
      remitToState: (isClient && clientDetails?.isVendor && clientDetails?.remit_to_state_name) || '',
      remitToCountry: (isClient && clientDetails?.isVendor && clientDetails?.remit_to_country) ? (countries.find(c => c.code === clientDetails?.remit_to_country)?.label || clientDetails?.remit_to_country) : '',
      vendorTelephoneNumber: (isClient && clientDetails?.isVendor && clientDetails?.vendor_telephone_number) || '',
      vendorTelephoneExtension: (isClient && clientDetails?.isVendor && clientDetails?.vendor_telephone_extension) || '',
      vendorRepCellNumber: (isClient && clientDetails?.isVendor && clientDetails?.vendor_rep_cell_number) || '',
      vendorRepName: (isClient && clientDetails?.isVendor && clientDetails?.vendor_rep_name) || '',
      vendorOrderEmail: (isClient && clientDetails?.isVendor && clientDetails?.main_order_email) || '',
      vendorAccountingEmail: (isClient && clientDetails?.isVendor && clientDetails?.secondary_accounting_email) || '',
      vendorAccountingPhoneNumber: (isClient && clientDetails?.isVendor && clientDetails?.secondary_accounting_phone) || '',
      vendorWebsite: (isClient && clientDetails?.isVendor && clientDetails?.website_url) || '',
      vendorRemitToName: (isClient && clientDetails?.isVendor && clientDetails?.remit_to_name) || '',
      vendorNotes: (isClient && clientDetails?.isVendor && clientDetails?.vendor_note) || '',
      coiOnFile: (isClient && clientDetails?.isVendor && Number(clientDetails?.coi_on_file || 0) === 1) || false,
      customerAccountNumber: (isClient && clientDetails?.isVendor && clientDetails?.customer_account_number) || '',
      licence_number:(isDriver && driverData?.licence_number)||'',
      licence_image:(isDriver && driverData?.licence_image)||'',
      hourly_rate:(isDriver && driverData?.hourly_rate)||'',
      blood_group:(isDriver && driverData?.blood_group)||'',
      gender:(isDriver && driverData?.gender)||'',
      selectworkflows: namesArray && namesArray || '',
      customerType :customerTypeData,
      role:(isClient && clientDetails)? userRoles.find(val=> val.id == clientDetails.user_type):isTeam && userData?.user_role || null
    },
    validationSchema: UpdateUserSchema,
    onSubmit: async (values, { resetForm, setErrors, setSubmitting }) => {
      try {
        if (internalNoteState === true) {
          const internalNote = values.about
          
          if(isClient==true){
           const clientNoteResponse = await axios.post(`${REST_API_END_POINT}clients/add-internal-note`,
           {internalNote,userId,clientId:clientId})
           if(clientNoteResponse.data.status==1){
            enqueueSnackbar(clientNoteResponse.data.message, {
              variant: 'success',
            })
            fetchViewClientData()  // if temporary data 
            
            resetForm()
           }else{
            enqueueSnackbar('Internal note updation error', {
              variant: 'error',
            })
           }
          }else if(isTeam ==true){
          const internalNoteResult = await axios.post(
            `${REST_API_END_POINT}teams/add-internal-note`,
            { receivedId, userId, internalNote },
          )
          
          if (internalNoteResult.data.status === 1) {
            enqueueSnackbar('Internal note updated successfully', {
              variant: 'success',
            })
            navigate(PATH_DASHBOARD.callCenter.teams)
            resetForm()
          } else {
            enqueueSnackbar('Internal note updation error', {
              variant: 'error',
            })
          }
        }
        setInternalNote(false)
          setSubmitting(false)
        }
      } catch (error) {
        setErrors()
        setSubmitting(false)
      }
    },
  })

  const {
    values,
    errors,
    touched,
    isSubmitting,
    handleSubmit,
    getFieldProps,
    setFieldValue,
  } = formik
  
  useEffect(() => {
    if (taxExemptAttachments) {
      setImages(taxExemptAttachments.filter(attachment => attachment.file_type?.startsWith('image')));
      setPdfs(taxExemptAttachments.filter(attachment => attachment.file_type === 'application/pdf'));
    }
  }, [clientTaxExemptAttachments]);

  const handleResetInternalNote = (formik) => {
    setInternalNote(false)
    formik.resetForm();
  }
   console.log('isClientisClient',isClient)
  const changeStatus = async (teamId, teamStatus) => {
    try {
      let status = teamStatus
     
      let response = await axios.post(
        `${REST_API_END_POINT}teams/delete-team-members`,
        { teamId, status, userId },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      )
      
      if (response.data.status === 1) {
        enqueueSnackbar(response.data.message, { variant: 'success' })
      } else if (response.data.status === 0) {
        enqueueSnackbar(response.data.message, { variant: 'error' })
      } else {
        
        enqueueSnackbar('Error.........!', { variant: 'error' })
      }
    } catch (error) {
      console.log('Delete error : ', error)
    }
  }

  const addWorkflowSubmit = async () => {
    try {
      setWorkflows(false)
      if (values.newWorkflow) {
        let workflowIds
        let combinedIdsArray
        let newWorkflowIds = values.newWorkflow.map((workflow) => workflow.id)
        // if (idsArray) {
        //   combinedIdsArray = idsArray.concat(newWorkflowIds)
        //   workflowIds = combinedIdsArray.join(',')
        // } else {
        //   workflowIds = newWorkflowIds.join(',')
        // }
        workflowIds = newWorkflowIds.join(',')
        if(isClient){
          let res = await axios.post(`${REST_API_END_POINT}clients/manage-workflow`,{
            workflowIds,receivedId:clientId,userId
          })
          if (res.data.status === 1) {
           
            enqueueSnackbar(res.data.message, { variant: 'success' })
          } else {
            enqueueSnackbar(res.data.message, { variant: 'error' })
          }
        }  else{
          ///this api call  is for team
        let response = await axios.post(
          `${REST_API_END_POINT}teams/update-workflows`,
          { receivedId, workflowIds, userId },
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        )
        
        if (response.data.status === 1) {
          enqueueSnackbar(response.data.message, { variant: 'success' })
          // navigate(PATH_DASHBOARD.callCenter.teamaccount, { state: { data: receivedId, isTeam: true } })
          navigate(PATH_DASHBOARD.callCenter.teams)
        } else {
          enqueueSnackbar(response.data.message, { variant: 'error' })
          // navigate(PATH_DASHBOARD.callCenter.teams);
          navigate(PATH_DASHBOARD.callCenter.teamaccount, {
            state: { data: receivedId, isTeam: true },
          })
        }
      }
      } else {
        navigate(PATH_DASHBOARD.callCenter.teamaccount, {
          state: { data: receivedId, isTeam: true },
        })
      }
    } catch (error) {
      console.log('addWorkflowSubmit error - ', error)
    }
  }
  const handleDeletClient=async(id,status)=>{
    try {
      if(isClient){
     const data={id:id,status:status}
     const res = await axios.post(`${REST_API_END_POINT}clients/remove-client`,data)
     
      if(res.data.status ==1){
      enqueueSnackbar(res.data.message,{variant:'success'})
      closePopover()
      navigate(PATH_DASHBOARD.client.cards)
      }else if(res.data.status ==0){
       enqueueSnackbar(res.data.message,{variant:'error'})
       closePopover()
       navigate(PATH_DASHBOARD.client.cards)
      }
    }
    } catch (error) {
      console.log(error,'Error in deleting client')
    }
  }

  const addRequestSubmit = async () => {
    try {
      setRequest(false)
      if (isClient) {
        
        if (values.clientRequestcheckbox) {
           let request_id=values.clientRequestcheckbox.id

          let response = await axios.post(
            `${REST_API_END_POINT}request/add-clients`,
            { request_id,values , userId },
            {
              headers: {
                'Content-Type': 'application/json',
              },
            },
          )
          
          if (response.data.status === 1) {
            enqueueSnackbar(response.data.message, { variant: 'success' })
          
            setRequest(false)
            closePopover()
            setRefreshData(!refreshData)
            
          } else {
            enqueueSnackbar(response.data.message, { variant: 'error' })
            // navigate(PATH_DASHBOARD.callCenter.teams);
            setRequest(false)
            closePopover()
           
          }
        } else {
          setRequest(false)
          closePopover()
         
        }
      } else {
        navigate(PATH_DASHBOARD.callCenter.teamaccount, {
          state: { data: receivedId, isTeam: true },
        })
      }
    } catch (error) {
      console.log('addRequestSubmit error ', error)
    }
  }

const onCopy = (state) => {
  setPassword({ value: state, copied: true });
  if (state) {
    enqueueSnackbar('Copied', { variant: 'success' });
  }
};

const handleEditClient = (isVendor , clientId)=>{
  const editClient = isVendor ? 'vendor' : 'client' 
  setClientEdit(editClient)
  setClientId(clientId)
  setViewAccount("editClient")

}

  const getAttachmentViewUrl = (attachment) => {
    const rawUrl = attachment?.url || '';
    const rawFileName = rawUrl?.split('/').pop()?.split('?')[0] || '';
    const fileExt = (attachment?.extension || rawFileName.split('.').pop() || '').toLowerCase();
    const officeViewerFormats = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
    const googleViewerFormats = ['csv', 'eps', 'ai', 'psd', 'tif', 'tiff', 'bmp', 'webp', 'ps'];
    const isPublicUrl = rawUrl.startsWith('http');

    if (isPublicUrl && officeViewerFormats.includes(fileExt)) {
      return `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(rawUrl)}`;
    }

    if (isPublicUrl && googleViewerFormats.includes(fileExt)) {
      return `https://docs.google.com/gview?url=${encodeURIComponent(rawUrl)}`;
    }

    return rawUrl;
  };

  const getAttachmentEmbedUrl = (attachment) => {
    const rawUrl = attachment?.url || '';
    const rawFileName = rawUrl?.split('/').pop()?.split('?')[0] || '';
    const fileExt = (attachment?.extension || rawFileName.split('.').pop() || '').toLowerCase();
    const officeViewerFormats = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
    const googleViewerFormats = ['csv', 'eps', 'ai', 'psd', 'tif', 'tiff', 'bmp', 'webp', 'ps'];
    const isPublicUrl = rawUrl.startsWith('http');

    if (isPublicUrl && officeViewerFormats.includes(fileExt)) {
      return `https://view.officeapps.live.com/op/embed.aspx?src=${encodeURIComponent(rawUrl)}`;
    }

    if (isPublicUrl && googleViewerFormats.includes(fileExt)) {
      return `https://docs.google.com/gview?url=${encodeURIComponent(rawUrl)}&embedded=true`;
    }

    return '';
  };

  const openAttachment = (attachment) => {
    const viewUrl = getAttachmentViewUrl(attachment);
    if (viewUrl) {
      window.open(viewUrl, '_blank');
    }
  };

  const attachmentToDownloadFile = (attachment) =>
    attachment
      ? {
          url: attachment.url,
          name:
            attachment.client_name ||
            attachment.url?.split('/').pop()?.split('?')[0],
          file_type: attachment.file_type,
          extension: attachment.extension,
        }
      : null;

  const openAttachmentPreview = (attachment) => {
    if (!attachment?.url) return;
    setPreviewAttachment(attachment);
    setPreviewPdfLoading(true);
    setPreviewUseOfficeViewer(true);
    setAttachmentPreviewOpen(true);
  };

  const renderCardDownloadButton = (attachment, position = 'top-right') => {
    if (!canDownloadFiles) return null;
    const positionSx =
      position === 'top-left'
        ? { top: 8, left: 8 }
        : { top: 8, right: 8 };
    return (
      <Box
        sx={{ position: 'absolute', ...positionSx, zIndex: 3 }}
        onClick={(e) => e.stopPropagation()}
      >
        <AttachmentDownloadIconButton
          file={attachmentToDownloadFile(attachment)}
          variant="overlay"
        />
      </Box>
    );
  };

  const renderAttachmentSection = (title, attachments = []) => {
    if (!attachments.length) {
      return null;
    }

    return (
      <Box sx={{ width: '100%' }}>
        <Typography variant="h6" sx={{ mb: 1 }}>
          {title}
        </Typography>
        <Box
          sx={{
            maxHeight: 620,
            overflowY: 'auto',
            overflowX: 'hidden',
            pr: 1,
            mr: -1,
            '&::-webkit-scrollbar': {
              width: 8,
            },
            '&::-webkit-scrollbar-thumb': {
              borderRadius: 8,
              bgcolor: 'text.disabled',
            },
            '&::-webkit-scrollbar-track': {
              borderRadius: 8,
              bgcolor: 'background.neutral',
            },
          }}
        >
          <Grid container spacing={2}>
            {attachments.map((attachment) => {
            const isImage = attachment.file_type?.startsWith('image');
            const isPdf = attachment.file_type === 'application/pdf' || attachment.extension === 'pdf';
            const rawFileName = attachment.url?.split('/').pop()?.split('?')[0] || 'Document';
            const fileName = decodeURIComponent(rawFileName).replace(/^\d+_/, '').replace(/_/g, ' ');
            const extension = (attachment.extension || fileName.split('.').pop() || 'file').toUpperCase();
            const fileSize = attachment.size ? fData(attachment.size) : '';
            const embedUrl = getAttachmentEmbedUrl(attachment);

            return (
              <Grid item xs={12} sm={4} md={4} key={attachment.attachment_id || attachment.id || attachment.url}>
                <Card
                  sx={{
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    border: (theme) => `1px solid ${theme.palette.divider}`,
                    boxShadow: 'none',
                  }}
                >
                  {isImage ? (
                    <>
                      <Box sx={{ position: 'relative', overflow: 'hidden' }}>
                        {renderCardDownloadButton(attachment, 'top-left')}
                        <CardMedia
                          component="img"
                          height="140"
                          image={attachment.url}
                          alt={fileName}
                          sx={{ cursor: 'pointer', objectFit: 'cover' }}
                          onClick={() => openAttachmentPreview(attachment)}
                        />
                        <IconButton
                          sx={{
                            position: 'absolute',
                            top: 8,
                            right: 8,
                            color: 'white',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' },
                          }}
                          onClick={() => openAttachmentPreview(attachment)}
                        >
                          <FullscreenIcon />
                        </IconButton>
                      </Box>
                      <CardContent sx={{ flexGrow: 1 }}>
                        <Typography variant="subtitle2" title={fileName} noWrap>
                          {fileName}
                        </Typography>
                        {fileSize && (
                          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                            {fileSize}
                          </Typography>
                        )}
                      </CardContent>
                    </>
                  ) : isPdf ? (
                    <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                      <Stack spacing={2} sx={{ height: '100%' }}>
                        <Box
                          sx={{
                            height: 140,
                            borderRadius: 1.5,
                            bgcolor: 'background.neutral',
                            overflow: 'hidden',
                            position: 'relative',
                          }}
                        >
                          {renderCardDownloadButton(attachment, 'top-left')}
                          <Box
                            sx={{
                              width: '100%',
                              height: '100%',
                              bgcolor: 'background.neutral',
                              pointerEvents: 'none',
                            }}
                          />
                          <IconButton
                            sx={{
                              position: 'absolute',
                              top: 8,
                              right: 8,
                              color: 'white',
                              backgroundColor: 'rgba(0, 0, 0, 0.5)',
                              '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' },
                            }}
                            onClick={() => openAttachmentPreview(attachment)}
                          >
                            <FullscreenIcon />
                          </IconButton>
                        </Box>
                        <Box sx={{ minWidth: 0 }}>
                          <Typography variant="subtitle2" title={fileName} noWrap>
                            {fileName}
                          </Typography>
                          {fileSize && (
                            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                              {fileSize}
                            </Typography>
                          )}
                        </Box>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Chip
                            size="small"
                            label={extension}
                            sx={{ width: 'fit-content' }}
                          />
                        </Stack>
                        <Button
                          size="small"
                          variant="contained"
                          fullWidth
                          sx={{ mt: 'auto' }}
                          onClick={() => openAttachmentPreview(attachment)}
                        >
                          Open File
                        </Button>
                      </Stack>
                    </CardContent>
                  ) : (
                    <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                      <Stack spacing={2} sx={{ height: '100%' }}>
                        {embedUrl ? (
                          <Box
                            onClick={() => openAttachmentPreview(attachment)}
                            sx={{
                              height: 140,
                              borderRadius: 1.5,
                              bgcolor: 'background.neutral',
                              overflow: 'hidden',
                              cursor: 'pointer',
                              position: 'relative',
                            }}
                          >
                            {renderCardDownloadButton(attachment, 'top-left')}
                            <iframe
                              src={embedUrl}
                              title={fileName}
                              width="300%"
                              height="300%"
                              frameBorder="0"
                              style={{
                                border: 'none',
                                pointerEvents: 'none',
                                transform: 'scale(0.33)',
                                transformOrigin: 'top left',
                              }}
                            />
                            <IconButton
                              sx={{
                                position: 'absolute',
                                top: 8,
                                right: 8,
                                color: 'white',
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' },
                              }}
                              onClick={(event) => {
                                event.stopPropagation();
                                openAttachmentPreview(attachment);
                              }}
                            >
                              <FullscreenIcon />
                            </IconButton>
                          </Box>
                        ) : (
                          <Box
                            sx={{
                              height: 140,
                              borderRadius: 1.5,
                              bgcolor: 'background.neutral',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              position: 'relative',
                            }}
                          >
                            {renderCardDownloadButton(attachment, 'top-left')}
                            <Typography variant="h4" sx={{ fontWeight: 700, color: 'text.secondary' }}>
                              {extension}
                            </Typography>
                            <IconButton
                              sx={{
                                position: 'absolute',
                                top: 8,
                                right: 8,
                                color: 'white',
                                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                '&:hover': { backgroundColor: 'rgba(0, 0, 0, 0.7)' },
                              }}
                              onClick={() => openAttachmentPreview(attachment)}
                            >
                              <FullscreenIcon />
                            </IconButton>
                          </Box>
                        )}
                        <Box sx={{ minWidth: 0 }}>
                          <Typography variant="subtitle2" title={fileName} noWrap>
                            {fileName}
                          </Typography>
                          {fileSize && (
                            <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                              {fileSize}
                            </Typography>
                          )}
                        </Box>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Chip
                            size="small"
                            label={extension}
                            sx={{ width: 'fit-content' }}
                          />
                        </Stack>
                        <Button
                          size="small"
                          variant="contained"
                          fullWidth
                          sx={{ mt: 'auto' }}
                          onClick={() => openAttachmentPreview(attachment)}
                        >
                          Open File
                        </Button>
                      </Stack>
                    </CardContent>
                  )}
                  {isImage && (
                    <Box sx={{ px: 2, pb: 2 }}>
                      <Button
                        size="small"
                        variant="contained"
                        fullWidth
                        onClick={() => openAttachmentPreview(attachment)}
                      >
                        Open File
                      </Button>
                    </Box>
                  )}
                </Card>
              </Grid>
            );
            })}
          </Grid>
        </Box>
      </Box>
    );
  };

  return (
    loading ? 
      <Stack alignItems='center' justifyContent='center'>
        <CircularProgress color="primary" variant="indeterminate" />
      </Stack>
    :
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Card sx={{ py: 5, px: 3, textAlign: 'center' }}>
              {isClient && (
                <Grid container justifyContent="flex-start">
                  <Grid item xs={12} sm={6} sx={{ mb: 5 }}>
                    <Box sx={{ textAlign: { sm: 'left' } }}>
                      <Typography sx={{color:clientDetails?.bg_color}} variant='subtitle2'>
                       {clientDetails?.partner_type_name}
                       </Typography>
                    </Box>
                    <Box sx={{ textAlign: { sm: 'left',md:'left' } }}>
                      <Typography variant='caption'>
                       {clientDetails?.partner_type_description}
                       </Typography>
                    </Box>
                  </Grid>
                </Grid>
              )}
                
              {/* First Section */}
              <Box sx={{ mb: 3, paddingBottom: '30px' }}>
                <Avatar
                  alt={ isClient ?clientDetails?.company_name:values.displayName}
                  src={ isClient ?clientDetails?.profile_pic:values.photoURL}
                  sx={{ width: 150, height: 150, margin: 'auto' }}
                />
                {userData && (
                  <span
                    style={{
                      width: '13px',
                      height: '13px',
                      borderRadius: '50%',
                      marginLeft: '50px',
                      marginTop: '-30px',
                      position: 'absolute',
                      zIndex: 13,
                      backgroundColor:
                        userData.active == 'Y' ? '#00FF00' : '#fc3838',
                    }}
                  ></span>
                )}

                <Typography
                  variant="h4"
                  //variant="caption"
                  sx={{
                    mt: 5,
                    // mt: 2,
                    mx: 'auto',
                    display: 'block',
                    textAlign: 'center',
                    // color: 'text.secondary'
                  }}
                >
                  {capitalCase(values.displayName)}
                </Typography>
                  {isDriver && (
                    <Card>
                    <CardHeader sx={{justifyContent:'flex-start'}} title='Licence'/>
                    <CardMedia
                    component="img"
                    height="140"
                    loading='lazy'
                    image={values?.licence_image}
                     />
                     </Card>
                  )}
                {/* {isClient && (
                  <Box
                    component="fieldset"
                    mb={3}
                    borderColor="transparent"
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Rating name="read-only" value={Number(clientDetails?.rating)} readOnly />
                  </Box>
                )} */}

                {/* {isClient && (
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'center',
                      mt: 2,
                      mb: 2.5,
                    }}
                  >
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <Typography
                        variant="body2"
                        sx={{ cursor: 'pointer', color: 'primary.main' }}
                      >
                        {clientDetails?.no_of_reviews} Reviews
                      </Typography>
                    </Stack>
                  </Box>
                )} */}

                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    mt: 2,
                    mb: 2.5,
                  }}
                >
                  <Stack direction="row" alignItems="center" spacing={1}>
                    <Typography
                      variant="body2"
                      sx={{ cursor: 'pointer', color: 'primary.main' }}
                    >
                      {/* <Icons icon={location-city} width={30} height={30} color="#006097" /> */}
                      {`${values.city}`}
                      {values.city && values.state ? ' , ' : ''}
                      {`${values.state}`}
                    </Typography>
                  </Stack>
                </Box>
                {
                (isAdminUser (userType) || userType ==3 || 
                  (explodedPermissions?.some(permission => ['Delete team members', 'Edit team members', 'Edit clients','Delete clients', 'Edit Vendors','Delete Vendors'].includes(permission))))
                ?
                <Grid item sx={{ marginTop: '20px' }}>
                {(isTeam ||(isClient&&clientDetails?.user_id))?
                  (<Button
                    sx={{ marginTop: '10px' }}
                    onClick={openPopover}
                    variant="contained"
                  >
                    Actions ***
                  </Button>):null}
                  <Popover
                    sx={{ marginTop: '40px' }}
                    open={Boolean(popoverAnchor)}
                    anchorEl={popoverAnchor}
                    onClose={closePopover}
                    anchorOrigin={{
                      vertical: 'center', // Updated to 'top'
                      horizontal: 'right',
                    }}
                    transformOrigin={{
                      vertical: 'center',
                      horizontal: 'left',
                    }}
                  >
                    <Paper
                      sx={{
                        maxWidth: '300px', // Adjust the width as per your requirement
                        maxHeight: 210,
                        overflow: 'auto',
                        '&::-webkit-scrollbar': {
                          width: '0.4em',
                        },
                        '&::-webkit-scrollbar-track': {
                          boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                          webkitBoxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
                        },
                        '&::-webkit-scrollbar-thumb': {
                          backgroundColor: 'rgba(0,0,0,.1)',
                          borderRadius: '4px',
                        },
                      }}
                    >
                      <Stack direction="column" spacing={2} sx={{ p: 2 }}>
                        {
                          userType !==3 &&
                        
                       <Typography
                          onClick={
                            isTeam
                              ? () => {
                                  // navigate(<Messages id={receivedId}/>)
                                  closePopover()
                                  navigate(
                                    PATH_DASHBOARD.callCenter.teamaccount,
                                    { state: { data: receivedId } },
                                  )
                                  setCurrentTab('Messages') // Set the desired tab as active
                                }
                              : () => {
                                  closePopover()
                                  setMessage(true)
                                  // navigate(`/dashboard/client/account/${clientId}`)
                                  // navigate(PATH_DASHBOARD.client.account) 
                                  setCurrentTab('Messages') // Set the desired tab as active
                                }
                          }
                          component="div"
                          variant="body1"
                          sx={{
                            cursor: 'pointer',
                            textAlign: 'left',
                            color: 'primary.main',
                            '&:hover': { color: theme.palette.mode === 'light' ? '#2986cc' : 'white' },
                          }}
                        >
                          Send Message
                        </Typography>
}
                        {isClient && (
                          <>
                          {
                          userType !==3 &&
                        <Typography
                          onClick={() => {
                            closePopover()
                            setRequest(!request)
                          }}
                          variant="body1"
                          component="div"
                          sx={{
                            cursor: 'pointer',
                            textAlign: 'left',
                            color: 'primary.main',
                            '&:hover': { color: theme.palette.mode === 'light' ? '#2986cc' : 'white' },
                          }}
                        >
                          Add to Request
                        </Typography>
}

                        
                          {/* <Typography
                            onClick={() => {
                              setIsReviewFormOpen((prev) => !prev)
                            }}
                            variant="body1"
                            component="div"
                            sx={{
                              cursor: 'pointer',
                              textAlign: 'left',
                              color: 'primary.main',
                              '&:hover': { color: 'white' },
                            }}
                          >
                            Add Review
                          </Typography> */}
                          </>
                        )}

                        {/* {isClient && (
                          <Typography
                            onClick={() => {
                              setGroup(!group)
                            }}
                            variant="body1"
                            component="div"
                            sx={{
                              cursor: 'pointer',
                              textAlign: 'left',
                              color: 'primary.main',
                              '&:hover': { color: 'white' },
                            }}
                          >
                            Add to Group
                          </Typography>
                        )} */}
                        <Typography
                          onClick={() => {
                            if(isTeam && ((explodedPermissions?.some(permission => ['Delete team members'].includes(permission))) || userType ==3))
                            {
                              closePopover()
                              setDeleteTeam(!deleteTeam)
                            } else if((clientDetails?.isVendor && explodedPermissions?.some(permission => ['Delete Vendors'].includes(permission))) ||
                            (!clientDetails?.isVendor && explodedPermissions?.some(permission => ['Delete clients'].includes(permission))))
                            {
                              setOpenDeletePop(true)
                            } else{
                              enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' })
                            }
                          }}
                          variant="body1"
                          component="div"
                          sx={{
                            cursor: 'pointer',
                            textAlign: 'left',
                            color: 'primary.main',
                            '&:hover': { color: theme.palette.mode === 'light' ? '#2986cc' : 'white' },
                          }}
                        >
                          Remove {isTeam ? 'Team Member' : clientDetails?.isVendor ? 'Vendor' : 'Client'}
                        </Typography>
                     
                        <Typography
                          onClick={
                            isTeam
                              ? () => {
                                if(explodedPermissions?.some(permission => ['Edit team members'].includes(permission)) || userType ==3){
                                  closePopover()
                                  navigate(`/dashboard/client/edit/team/${receivedId}/${true}`)
                                }else{
                                  enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' })
                                }}
                              : () => {
                                if((clientDetails?.isVendor && explodedPermissions?.some(permission => ['Edit Vendors'].includes(permission))) ||
                                (!clientDetails?.isVendor && explodedPermissions?.some(permission => ['Edit clients'].includes(permission))))
                                {
                                  closePopover()
                                  handleEditClient(clientDetails.isVendor ,clientId )
                                  // navigate(`/dashboard/client/edit/${clientDetails.isVendor ? 'vendor' : 'client'}/${clientId}/${false}`)
                                }else{
                                  enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' })
                                }
                              }
                          }
                          variant="body1"
                          component="div"
                          sx={{
                            cursor: 'pointer',
                            textAlign: 'left',
                            color: 'primary.main',
                            '&:hover': { color: theme.palette.mode === 'light' ? '#2986cc' : 'white' },
                          }}
                        >
                          Edit Profile Information
                        </Typography>

                        {
                          userType !==3 &&
                        <Typography
                          onClick={
                            isTeam
                              ? () => {
                                  closePopover()
                                  setWorkflows(!workflows)
                                }
                              : () => {
                                  closePopover()
                                  setWorkflows(!workflows)
                                }
                          }
                          variant="body1"
                          component="div"
                          sx={{
                            cursor: 'pointer',
                            textAlign: 'left',
                            color: 'primary.main',
                            '&:hover': { color: theme.palette.mode === 'light' ? '#2986cc' : 'white' },
                          }}
                        >
                          Manage On Boarding Workflows
                        </Typography>
}
                      </Stack>
                    </Paper>
                  </Popover>              
                </Grid>
                : ''
                }
              </Box>

              <Divider sx={{ mb: 3,}} />
              <Grid
             container
            direction={{ xs: 'column', sm: 'row', md: 'row' }}
             spacing={1}
              flexWrap="wrap"
               >
             {tags?.map((obj) => (
             <Grid item key={obj.id}>
               <TagChip
                sx={{ mb: 1 }}
                  size={'small'}
                 label={obj.name}
                color={obj.color}
              variant={obj.variant}
              />
            </Grid>
            ))}
           </Grid>

              {/* Second Section */}
              {/* {isClient && (
                <Box
                  sx={{
                    mx: 0,
                    mb: 3,
                    width: 1,
                    display: 'flex',
                    justifyContent: 'space-between',
                  }}
                >
                  <Box>
                    <Typography
                      variant="subtitle2"
                      sx={{ mb: 0.5, color: 'text.primary' }}
                    >
                      Relationship managers
                    </Typography>
                    <Stack direction="row" alignItems="center" spacing={1}>
                      <GroupIcon color="primary" fontSize="small" />
                      <Typography
                        variant="body2"
                        sx={{ cursor: 'pointer', color: 'primary.main' }}
                        onClick={() => {
                          setPopup(!popup)
                        }}
                      >
                        Relationship managers
                      </Typography>
                    </Stack>
                  </Box>
                </Box>
              )} */}
            </Card>
          </Grid>
         
          {/* Set Relationship Managers */}
          <Modal
            open={popup}
            handleClose={() => {
              setPopup(false)
            }}
            modalTitle={'Set Relationship Managers'}
          >
            <FormikProvider value={formik}>
              <Form noValidate autoComplete="off">
                <Stack
                  direction={{ xs: 'column', sm: 'column' }}
                  spacing={{ xs: 3, sm: 2 }}
                >
                  <Autocomplete
                    multiple
                    fullWidth
                    id="checkboxes-tags-demo"
                    options={Workflow}
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.label}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox checked={selected} />
                        {option.label}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Relationship Managers"
                        placeholder="Relationship Managers"
                        error={Boolean(touched.Workflow && errors.Workflow)}
                        helperText={touched.Workflow && errors.Workflow}
                        fullWidth // add this line to make the Autocomplete component full width
                      />
                    )}
                  />
                </Stack>

                <Grid container justifyContent="center" alignItems="center">
                  <Grid item xs={12} md={4}>
                    <Box
                      sx={{
                        mt: 3,
                        display: 'flex',
                        justifyContent: 'center',
                        gap: 1,
                      }}
                    >
                      <LoadingButton
                        type="submit"
                        variant="contained"
                        onClick={() => {
                          setPopup(false)
                        }}
                        loading={isSubmitting}
                      >
                        Add
                      </LoadingButton>
                      <Button
                        variant="outlined"
                        onClick={() => {
                          setPopup(false)
                        }}
                      >
                        Cancel
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Form>
            </FormikProvider>
          </Modal>
                         {/* deleteing client  */}
          <ConfirmationPopup 
                          open={openDeletePop}
                          handleClose={()=>{setOpenDeletePop(false),closePopover()}}
                          message={`You want to delete ${clientDetails?.name} ! `}
                          handleClick={()=>{handleDeletClient(clientId,2)}}
                          />

          {/* Add To Request */}
          <Modal
            open={request}
            handleClose={() => {
              setRequest(false)
            }}
            modalTitle={'Add To Request'}
          >
            <FormikProvider value={formik}>
              <Form noValidate autoComplete="off">
                <Stack
                  direction={{ xs: 'column', sm: 'column' }}
                  spacing={{ xs: 3, sm: 2 }}
                >
                  {isClient ? (
                    <Autocomplete
                      fullWidth
                      id="clientRequestcheckbox"
                      options={allClientRequest}
                      disableCloseOnSelect={true}
                      getOptionLabel={(option) => option.name}
                      renderOption={(props, option, { selected }) => (
                        <li {...props}>
                          <Checkbox
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option.name}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Add to request"
                          placeholder="Search requests"
                          error={Boolean(
                            touched.clientRequestcheckbox &&
                              errors.clientRequestcheckbox,
                          )}
                          helperText={
                            touched.clientRequestcheckbox &&
                            errors.clientRequestcheckbox
                          }
                        />
                      )}
                      // value={values.teamRequestcheckbox}
                      onChange={(event, newValue) => {
                        setFieldValue('clientRequestcheckbox', newValue)
                        
                      }}
                    />
                  ) : (
                    <Autocomplete
                      multiple
                      fullWidth
                      id="checkboxes-tags-demo"
                      options={Request}
                      disableCloseOnSelect
                      getOptionLabel={(option) => option.label}
                      renderOption={(props, option, { selected }) => (
                        <li {...props}>
                          <Checkbox checked={selected} />
                          {option.label}
                        </li>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Add To Request"
                          placeholder="Add To Request"
                          error={Boolean(touched.Request && errors.Request)}
                          helperText={touched.Request && errors.Request}
                          fullWidth // add this line to make the Autocomplete component full width
                        />
                      )}
                    />
                  )}
                </Stack>

                <Grid container justifyContent="center" alignItems="center">
                  <Grid item xs={12} md={4}>
                    <Box
                      sx={{
                        mt: 3,
                        display: 'flex',
                        justifyContent: 'center',
                        gap: 1,
                      }}
                    >
                      <Button
                        type="submit"
                        variant="contained"
                        onClick={() => {
                          addRequestSubmit()
                        }}
                      >
                        Add
                      </Button>
                      <Button
                        variant="outlined"
                        onClick={() => {
                          setRequest(false)
                        }}
                      >
                        Cancel
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Form>
            </FormikProvider>
          </Modal>

          {/* Add To Group */}
          <Modal
            open={group}
            handleClose={() => {
              setGroup(false)
            }}
            modalTitle={'Add To Group'}
          >
            <FormikProvider value={formik}>
              <Form noValidate autoComplete="off">
                <Stack
                  direction={{ xs: 'column', sm: 'column' }}
                  spacing={{ xs: 3, sm: 2 }}
                >
                  <Autocomplete
                    multiple
                    fullWidth
                    id="checkboxes-tags-demo"
                    options={Group}
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.label}
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox checked={selected} />
                        {option.label}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Add To Group"
                        placeholder="Add To Group"
                        error={Boolean(touched.Group && errors.Group)}
                        helperText={touched.Group && errors.Group}
                        fullWidth // add this line to make the Autocomplete component full width
                      />
                    )}
                  />
                </Stack>

                <Grid container justifyContent="center" alignItems="center">
                  <Grid item xs={12} md={4}>
                    <Box
                      sx={{
                        mt: 3,
                        display: 'flex',
                        justifyContent: 'center',
                        gap: 1,
                      }}
                    >
                      <LoadingButton
                        type="submit"
                        variant="contained"
                        onClick={() => {
                          setGroup(false)
                        }}
                        loading={isSubmitting}
                      >
                        {' Add '}
                      </LoadingButton>
                      <Button
                        variant="outlined"
                        onClick={() => {
                          setGroup(false)
                        }}
                      >
                        Cancel
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Form>
            </FormikProvider>
          </Modal>
      
          {/* Manage Onboarding Workflows */}
          {console.log("#############workflows",values)}
          <Modal
            open={workflows}
            handleClose={() => {  
              setWorkflows(false)
            }}
            modalTitle={'Manage Workflows'}
          >
             
            <FormikProvider value={formik}>
              <Form noValidate autoComplete="off">
                <Stack
                  direction={{ xs: 'column', sm: 'column' }}
                  spacing={{ xs: 3, sm: 2 }}
                >
                  {/* {namesArray &&
                    namesArray.map((name) => (
                      <TextField fullWidth value={name} disabled />
                    ))} */}
                  <Typography variant="body1" sx={{ color: 'primary.main' }}>
                    Select Workflows
                  </Typography>
                  {isClient ? (
                     <Autocomplete
                     multiple
                     fullWidth
                     id="newWorkflow"
                     options={clientworkFlow?clientworkFlow:[]}
                     getOptionLabel={(state) => state.name}
                     onChange={(event, value) => {
                       setFieldValue('newWorkflow', value)
                       setFieldValue('selectworkflows',value)
                     }}
                     defaultValue={values.selectworkflows}
                    
                     // sx={{ width: 400 }}
                     renderInput={(params) => (
                       <TextField
                         {...params}
                         label="Type to search workflows"
                         error={Boolean(
                           touched.newWorkflow && errors.newWorkflow,
                         )}
                         helperText={touched.newWorkflow && errors.newWorkflow}
                       />
                     )}
                   />
                  ):(
                  <Autocomplete
                    multiple
                    fullWidth
                    id="newWorkflow"
                    options={teamworkflows?.filter((item)=>item.status==1)}
                    getOptionLabel={(state) => state.name}
                    onChange={(event, value) => {
                      setFieldValue('newWorkflow', value)
                    }}
                    defaultValue={values.selectworkflows}
                    // sx={{ width: 400 }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Type to search workflows"
                        error={Boolean(
                          touched.newWorkflow && errors.newWorkflow,
                        )}
                        helperText={touched.newWorkflow && errors.newWorkflow}
                      />
                    )}
                  />
                  )}
                </Stack>

                <Grid container justifyContent="center" alignItems="center">
                  <Grid item xs={12} md={4}>
                    <Box
                      sx={{
                        mt: 3,
                        display: 'flex',
                        justifyContent: 'center',
                        gap: 1,
                      }}
                    >
                      <Button
                        variant="contained"
                        onClick={() => {
                          addWorkflowSubmit()
                        }}
                      >
                        Save
                      </Button>
                      <Button
                        variant="outlined"
                        onClick={() => {
                          setWorkflows(false)
                        }}
                      >
                        Cancel
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Form>
            </FormikProvider>
          </Modal>

          {/* Delete confirmation */}
          <Modal
            open={deleteTeam}
            handleClose={() => {
              setDeleteTeam(false)
            }}
            // modalTitle={'Remove Team Member'}
          >
            <FormikProvider value={formik}>
              <Form noValidate autoComplete="off">
                <Stack
                  direction={{ xs: 'column', sm: 'column' }}
                  spacing={{ xs: 3, sm: 2 }}
                >
                  <Avatar
                    alt={values.displayName}
                    src={values.photoURL}
                    sx={{ width: 150, height: 150, margin: 'auto' }}
                  />
                  <Typography
                    variant="h5"
                    sx={{ color: 'primary.secondary', alignSelf: 'center' }}
                  >
                    Are you sure you want to delete {values.displayName} ?
                  </Typography>
                </Stack>
                <Grid container justifyContent="center" alignItems="center">
                  <Grid item xs={12} md={6}>
                    <Box
                      sx={{
                        my: 3,
                        display: 'flex',
                        justifyContent: 'center',
                        gap: 2,
                      }}
                    >
                      <Button
                        variant="contained"
                        onClick={() => {
                          changeStatus(receivedId, deleteStatus)
                          navigate(PATH_DASHBOARD.callCenter.teams)
                        }}
                      >
                        Yes, Delete it!
                      </Button>
                      <Button
                        variant="outlined"
                        onClick={() => {
                          setDeleteTeam(false)
                        }}
                      >
                        No, Cancel pls!
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Form>
            </FormikProvider>
          </Modal>
    {/* this is the display of name and other details */}
          <Grid item xs={12} md={8}>
            <Card sx={{ p: 3 }}>
              <Stack spacing={{ xs: 2, md: 3 }}>
                {/* First Section */}
                <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
                  <TextField
                    fullWidth
                    label="Name"
                    {...getFieldProps('displayName')}
                    disabled
                  />
                  <TextField
                    fullWidth
                    label="Email Address"
                    {...getFieldProps('email')}
                    disabled
                  />
                </Stack>

                {isTeam && (
                  <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
                    <TextField
                      fullWidth
                      label="Employee ID#"
                      value={userData?.id || ''}
                      disabled
                    />
                  </Stack>
                )}

                {clientDetails?.isVendor === 0 && clientDetails?.contact_name && (
                  <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
                    <TextField
                      fullWidth
                      label="Contact Name"
                      value={clientDetails?.contact_name || ''}
                      disabled
                    />
                  </Stack>
                )}

                  {clientDetails?.sales_rep_full_names &&
                    <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
                      {clientDetails?.sales_rep_full_names.split(',').map(name => name.trim()).length > 0 ? (
                        <Autocomplete
                          multiple
                          fullWidth
                          readOnly
                          options={clientDetails?.sales_rep_full_names.split(',').map(name => name.trim())}
                          getOptionLabel={(option) => option}
                          value={clientDetails?.sales_rep_full_names.split(',').map(name => name.trim())}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Sales Rep Names"
                              placeholder="Sales Reps"
                            />
                          )}
                          renderTags={(value, getTagProps) =>
                            value.map((option, index) => (
                              <Chip key={index} label={option} {...getTagProps({ index })} />
                            ))
                          }
                        />
                      ) : (
                        <Chip label="No Data" color="info" />
                      )}
                    </Stack>
                  }
                
                  {additionalEmails?.length > 0 &&
                    additionalEmails?.map((email, index) => (
                      <Stack key={index} direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                        <TextField
                          fullWidth
                          label={`Contact Name`}
                          value={email.contact_name}
                          disabled
                        />
                        <TextField
                          fullWidth
                          label={`Additional Emails`}
                          value={email.email}
                          disabled
                        />
                      </Stack>
                    ))}

                <LabelStyle>User Credentials</LabelStyle>
                <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
                <TextField
                    fullWidth
                    label="User Name"
                    // {...getFieldProps('email')}
                    value={userData?.email || userData?.phone || userData?.username ||  clientDetails?.username || driverData?.username || ''}
                    disabled
                  />             
                   <TextField
                    fullWidth                   
                    value={userData?.pass || clientDetails?.pass||driverData?.password || ''}
                     label={'Password'}
                     placeholder={'Password'}                   
                    InputProps={{
                     endAdornment: (
                      <InputAdornment position="end">
                      <CopyToClipboard text={userData?.pass || clientDetails?.pass||driverData?.password} onCopy={()=>onCopy(userData ? userData?.pass : clientDetails?.pass||driverData?.password)}>
                       <Tooltip title="Copy Clipboard">
                         <IconButton>
                      <Icon icon={copyFill} width={24} height={24} />
                     </IconButton>
                   </Tooltip>
                  </CopyToClipboard>
                 </InputAdornment>
                 )
                }}     
                  />
                </Stack>        
                {userPin && hasSwitchUserPinPermission && (
                  <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
                    <TextField
                      fullWidth
                      label="User PIN"
                      value={userPin || ''}
                      InputProps={{
                        readOnly: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            <CopyToClipboard
                              text={userPin || ''}
                              onCopy={() => onCopy(userPin || '')}
                            >
                              <Tooltip title="Copy Clipboard">
                                <IconButton>
                                  <Icon
                                    icon={copyFill}
                                    width={24}
                                    height={24}
                                  />
                                </IconButton>
                              </Tooltip>
                            </CopyToClipboard>
                          </InputAdornment>
                        ),
                      }}
                      helperText="Your unique 4-digit PIN for quick login"
                    />
                  </Stack>
                )}
                <Stack
                  direction={{ xs: 'column', md: 'row' }}
                  spacing={2}
                  alignItems={{ xs: 'stretch', md: 'flex-start' }}
                >
                  {values.phoneNumber && (
                    <Box sx={{ flex: { md: '1 1 0' }, minWidth: { md: 0 }, width: '100%' }}>
                      <PhoneNumberField
                        label="Phone Number"
                        country={values.phone_country_code}
                        value={`${values.phone_country_code}${values.phoneNumber}`}
                        disabled={true}
                        InputProps={{
                          endAdornment: isClient && (
                            <Button
                              onClick={() =>
                                values.phoneNumber
                                  ? window.open(
                                      `${PATH_CALL.root}?phone=${values.phoneNumber}&name=${values.displayName}`,
                                      '_blank',
                                      'width=500,height=1000',
                                    )
                                  : enqueueSnackbar('Contact number not available', { variant: 'error' })
                              }
                            >
                              <Icon icon={phoneCallFill} width={30} height={30} color="#006097" />
                            </Button>
                          ),
                        }}
                      />
                    </Box>
                  )}
                  {(isTeam || isClient) && (
                    <Box sx={{ flex: { md: '1 1 0' }, minWidth: { md: 0 }, width: '100%' }}>
                      <Typography variant="subtitle2" sx={{ mb: 1 }}>
                        Phone Extension
                      </Typography>
                      <TextField
                        fullWidth
                        variant="outlined"
                        value={
                          isTeam
                            ? (values.phone_extension != null ? String(values.phone_extension) : '')
                            : (clientDetails?.phone_extension != null ? String(clientDetails.phone_extension) : '')
                        }
                        disabled
                        hiddenLabel
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            minHeight: 56,
                          },
                        }}
                      />
                    </Box>
                  )}
                  {(values.forward_no && isTeam) && (
                    <Box sx={{ flex: { md: '1 1 0' }, minWidth: { md: 0 }, width: '100%' }}>
                      <PhoneNumberField
                        fullWidth
                        label="Call Forward Number"
                        country={values.forward_country_code}
                        value={`${values.forward_country_code}${values.forward_no}`}
                        disabled={true}
                        InputProps={{
                          endAdornment: isClient && (
                            <Button
                              onClick={() =>
                                values.forward_no
                                  ? window.open(
                                      `${PATH_CALL.root}?phone=${values.forward_no}&name=${values.displayName}`,
                                      '_blank',
                                      'width=500,height=1000',
                                    )
                                  : enqueueSnackbar('Contact number not available', { variant: 'error' })
                              }
                            >
                              <Icon icon={phoneCallFill} width={30} height={30} color="#006097" />
                            </Button>
                          ),
                        }}
                      />
                    </Box>
                  )}
                </Stack>
                <Box sx={{ flex: { md: '1 1 0' }, minWidth: { md: 0 }, width: '100%' }}>
                    <Typography variant="subtitle2" sx={{ mb: 1, color: 'text.secondary' }}>
                      {'\u200B'}
                    </Typography>
                    <TextField
                      fullWidth
                      label="Address"
                      {...getFieldProps('address')}
                      disabled
                      sx={{
                        '& .MuiOutlinedInput-root': {
                          minHeight: 56,
                        },
                      }}
                    />
                  </Box>
                {isDriver ? (
                  <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>               
                    {/* <TextField
                      fullWidth
                      label="Hourly Rate"
                      {...getFieldProps('hourly_rate')}
                      disabled
                    /> */}
                  </Stack>
                ) : (
                  <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
                    {/* {values.hourlyRate && (
                      <TextField
                        fullWidth
                        label="Hourly Rate"
                        {...getFieldProps('hourlyRate')}
                        disabled
                      />
                    )} */}
                    {(values.departmentName && isTeam) && (
                      <>
                      {
                        userType !==3 &&
                      
                      <TextField
                        fullWidth
                        label="Department"
                        {...getFieldProps('departmentName')}
                        disabled
                      />
                      }
                      </>
                    )}
                  </Stack>
                )}
                {isDriver && (
                <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>               
                    <TextField
                      fullWidth
                      label="Licence Number"
                      {...getFieldProps('licence_number')}
                      disabled
                    />        
                    {/* <TextField
                      fullWidth
                      label="Blood Group"
                      {...getFieldProps('blood_group')}
                      disabled
                    />  */}
                     <TextField
                      fullWidth
                      label="Gender"
                      {...getFieldProps('gender')}
                      disabled
                    />                
                </Stack>
                )}
                {isClient && clientDetails?.isVendor && (values.address || values.city || values.zipCode || values.state || values.country) ? (
                   <Box sx={{ p: 3, mb: 3, border: (theme) => `1px solid ${theme.palette.grey[500_32]}`, borderRadius: 2 }}>
                    <Typography variant="h6" sx={{ mb: 3 }}>
                      Primary Address
                    </Typography>
                    <Stack spacing={3}>
                      {values.address && (
                        <TextField
                          fullWidth
                          label="Address"
                          {...getFieldProps('address')}
                          disabled
                        />
                      )}
                      <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
                        {values.zipCode && (
                          <TextField
                            fullWidth
                            label="Zip/Code"
                            {...getFieldProps('zipCode')}
                            disabled
                          />
                        )}
                        {values.city && (
                          <TextField
                            fullWidth
                            label="City"
                            {...getFieldProps('city')}
                            disabled
                          />
                        )}
                        {values.state && (
                          <TextField
                            fullWidth
                            label="State/Region"
                            {...getFieldProps('state')}
                            disabled
                          />
                        )}
                        {values.country && (
                          <TextField
                            fullWidth
                            label="Country"
                            {...getFieldProps('country')}
                            disabled
                          />
                        )}
                      </Stack>
                    </Stack>
                  </Box>
                ) : (values.address || values.city || values.zipCode || values.state || values.country) ? (
                  <>
                    {values.address && (
                      <TextField
                        fullWidth
                        label="Address"
                        {...getFieldProps('address')}
                        disabled
                      />
                    )}
                    <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
                      {values.zipCode && (
                        <TextField
                          fullWidth
                          label="Zip/Code"
                          {...getFieldProps('zipCode')}
                          disabled
                        />
                      )}
                      {values.city && (
                        <TextField
                          fullWidth
                          label="City"
                          {...getFieldProps('city')}
                          disabled
                        />
                      )}
                      {values.state && (
                        <TextField
                          fullWidth
                          label="State/Region"
                          {...getFieldProps('state')}
                          disabled
                        />
                      )}
                      {values.country && (
                        <TextField
                          fullWidth
                          label="Country"
                          {...getFieldProps('country')}
                          disabled
                        />
                      )}
                    </Stack>
                  </>
                ) : null}
                {isClient && clientDetails?.isVendor == 1 && (values.remitToAddress || values.remitToCity || values.remitToZipCode || values.remitToState) && (
                   <Box sx={{ p: 3, mb: 3, border: (theme) => `1px solid ${theme.palette.grey[500_32]}`, borderRadius: 2 }}>
                    <Typography variant="h6" sx={{ mb: 3 }}>
                      Remit-To Address
                    </Typography>
                    <Stack spacing={3}>
                      {values.remitToAddress && (
                        <TextField
                          fullWidth
                          label="Remit-To Address"
                          {...getFieldProps('remitToAddress')}
                          disabled
                        />
                      )}
                      <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
                        {values.remitToCity && (
                          <TextField
                            fullWidth
                            label="Remit-To City"
                            {...getFieldProps('remitToCity')}
                            disabled
                          />
                        )}
                        {values.remitToZipCode && (
                          <TextField
                            fullWidth
                            label="Remit-To Zip Code"
                            {...getFieldProps('remitToZipCode')}
                            disabled
                          />
                        )}
                        {values.remitToState && (
                          <TextField
                            fullWidth
                            label="Remit-To State"
                            {...getFieldProps('remitToState')}
                            disabled
                          />
                        )}
                        {values.remitToCountry && (
                          <TextField
                            fullWidth
                            label="Remit-To Country"
                            {...getFieldProps('remitToCountry')}
                            disabled
                          />
                        )}
                      </Stack>
                    </Stack>
                  </Box>
                )}
                {isClient && clientDetails?.isVendor == 1 && (
                  <Box sx={{ p: 3, mb: 3, border: (theme) => `1px solid ${theme.palette.grey[500_32]}`, borderRadius: 2 }}>
                    {/* <Typography variant="h6" sx={{ mb: 3 }}>
                      Vendor Maintenance
                    </Typography> */}
                    <Stack spacing={3}>
                      {(values.vendorTelephoneNumber || values.vendorTelephoneExtension) && (
                        <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
                          {values.vendorTelephoneNumber && (
                            <TextField fullWidth label="Vendor Telephone Number" {...getFieldProps('vendorTelephoneNumber')} disabled />
                          )}
                          {/* {values.vendorTelephoneExtension && (
                            <TextField fullWidth label="Phone Extension" {...getFieldProps('vendorTelephoneExtension')} disabled />
                          )} */}
                        </Stack>
                      )}
                      {(values.vendorRepCellNumber || values.vendorRepName) && (
                        <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
                        {values.vendorRepName && (
                          <TextField fullWidth label="Vendor Rep Name" {...getFieldProps('vendorRepName')} disabled />
                        )}
                          {values.vendorRepCellNumber && (
                            <TextField fullWidth label="Vendor Rep Cell Number" {...getFieldProps('vendorRepCellNumber')} disabled />
                          )}
                        </Stack>
                      )}
                      {(values.vendorOrderEmail || values.vendorAccountingEmail) && (
                        <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
                          {values.vendorOrderEmail && (
                            // <TextField fullWidth label="Primary Email Address for Placing Orders" {...getFieldProps('vendorOrderEmail')} disabled />
                            <TextField fullWidth label="Primary Email Address" {...getFieldProps('vendorOrderEmail')} disabled />
                          )}
                          {values.vendorAccountingEmail && (
                            // <TextField fullWidth label="Secondary Email for Accounting Contact" {...getFieldProps('vendorAccountingEmail')} disabled />
                            <TextField fullWidth label="Secondary Email" {...getFieldProps('vendorAccountingEmail')} disabled />
                          )}
                        </Stack>
                      )}
                      {(values.vendorAccountingPhoneNumber || values.vendorWebsite) && (
                        <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
                          {values.vendorAccountingPhoneNumber && (
                            // <TextField fullWidth label="Secondary Telephone Number for Accounting Contact" {...getFieldProps('vendorAccountingPhoneNumber')} disabled />
                            <TextField fullWidth label="Secondary Telephone Number" {...getFieldProps('vendorAccountingPhoneNumber')} disabled />
                          )}
                          {values.vendorWebsite && (
                            <TextField fullWidth label="Vendor Website" {...getFieldProps('vendorWebsite')} disabled />
                          )}
                        </Stack>
                      )}
                      {(values.vendorRemitToName || values.customerAccountNumber) && (
                        <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
                          {values.vendorRemitToName && (
                            <TextField fullWidth label="Vendors Remit-To Name (Name to print on checks)" {...getFieldProps('vendorRemitToName')} disabled />
                          )}
                          {values.customerAccountNumber && (
                            <TextField fullWidth label="Customer Account Number" {...getFieldProps('customerAccountNumber')} disabled />
                          )}
                        </Stack>
                      )}
                      <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
                        {customerTypeData?.name && (
                          <TextField
                            fullWidth
                            label="Payment Terms"
                            value={`${customerTypeData?.name}${customerTypeData?.billing_type ? ` ( ${customerTypeData?.billing_type} % )` : ''}`}
                            disabled
                          />
                        )}
                        {values.coiOnFile && (
                          <TextField fullWidth label="COI on file" value="Yes" disabled />
                        )}
                      </Stack>
                            {values.vendorNotes && (
                            <TextField
                                 fullWidth
                                 multiline
                                 rows={4}
                                  label="Notes"
                               {...getFieldProps('vendorNotes')}
                                     disabled
                                   error={Boolean(touched.vendorNotes && errors.vendorNotes)}
                                   helperText={
                                     touched.vendorNotes && errors.vendorNotes
                                       ? errors.vendorNotes
                                   : `${(values.vendorNotes || '').length}/100 characters`
                                       }
                                       inputProps={{
                                          maxLength: 100
                                               }}
                                          />
                                        )}
                      {renderAttachmentSection('Insurances', insuranceAttachments)}
                      {renderAttachmentSection('Other Forms', otherFormAttachments)}
                    </Stack>
                  </Box>
                )}
                {isTeam ?
                <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
                  <TextField
                    fullWidth
                    label="User Role"
                    value={
                      typeof values.role === 'object' && values.role !== null
                        ? (values.role.name || '')
                        : (values.role || '')
                    }
                    disabled
                    InputLabelProps={{ shrink: true }}
                  />
                  {
                        userType !==3 &&
                  <Autocomplete
                    multiple
                    fullWidth
                    id="service"
                    disabled
                    options={ services ? services : [] }
                    getOptionLabel={(option) => option?.name}
                    defaultValue={values?.service || []}  // Set the default value here
                    value={values?.service}
                    onChange={(event, newValue) => setFieldValue('service', newValue)}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Skills and Services"
                        placeholder="Select Skills and Services"
                        fullWidth
                        SelectProps={{ native: true }}
                      />
                    )}
                  />
}
                </Stack> : ''}
                {(isClient && !clientDetails?.isVendor)?
                <>
                <Stack direction={{ xs: 'column', md: 'row' }} spacing={2}>
                      <Autocomplete
                      disabled
                      fullWidth
                      sx={{ width: 400 }}
                      id="partner-type"
                      options={customerTypeData || []}
                      value={customerTypeData || null}
                      onChange={(event, newValue) => setFieldValue('customerType', newValue)}
                      renderInput={(params) => (
                        <TextField {...params} label="Payment Terms" />
                      )}
                      // getOptionLabel={(option) => option?.name}
                      getOptionLabel={(option) => 
                        option?.name ? `${option?.name} ( ${option?.billing_type} % )` : ''
                      }
  
                    />

                    <Autocomplete
                       select
                       fullWidth
                       id="role"
                       options={userRoles}
                       disabled
                       value={values?.role}
                       getOptionLabel={(state) => state.name}
                       onChange={(event, value) => {
                         if (value) {
                           setFieldValue('role', value);
                         }
                         else{
                           setFieldValue('role', '');
                         }
                       }}
                       renderInput={(params) => (
                         <TextField {...params} label="Client User Role"
                           placeholder="Type to search User Role"
                           error={Boolean(touched.role && errors.role)}
                           helperText={touched.role && errors.role}
                         />
                       )}
                     />

                </Stack>

            {
               clientDetails?.avalaraTaxType ?

                <>
                          <Typography variant="h6" sx={{  textAlign: 'right' }}>
                            Avalara Tax Type
                          </Typography>
                         <Stack direction="row" spacing={{ xs: 3, sm: 2 }} justifyContent="flex-end" alignItems="center">
                          
                            <RadioGroup
                              row
                              value={String(clientDetails?.avalaraTaxType)}
                              // onChange={(event) => setFieldValue('avalaraTaxType', event.target.value)}
                              disabled
                              sx={{
                                pointerEvents: 'none', // disable clicks
                                '& .MuiFormControlLabel-root': {
                                  cursor: 'not-allowed', // show access denied cursor
                                },
                                '& .MuiTypography-root': {
                                  cursor: 'not-allowed', // label also shows same cursor
                                },
                              }}
                            >
                              <FormControlLabel
                                value="1"
                                control={<Radio color="primary" />}
                                label="Taxable Client"
                              />
                              <FormControlLabel
                                value="2"
                                control={<Radio color="primary" />}
                                label="Tax-Exempt Client"
                              />
                            </RadioGroup>
                       </Stack>
                </>
            :""
             }

                </>
                      :
                      ""
                    }
                  {String(clientDetails?.avalaraTaxType) === '2' && taxExemptAttachments.length > 0 && (
                    <>
                      <Stack direction="column" spacing={2}>
                        {/* Images Section */}
                        {images.length > 0 && (
                            <>
                            {images.length > 0 && (
                              <Grid container spacing={2} sx={{ mt: 1, display: 'flex', flexDirection: 'row', alignItems: 'flex-start' }}>
                                <Grid item xs={12}>
                                  <Typography variant="h6">Images</Typography>
                                </Grid>
                                {images.slice(imagePage * imageRowsPerPage, imagePage * imageRowsPerPage + imageRowsPerPage).map((attachment, index) => (
                                  <Grid item xs={12} sm={4} md={4} key={attachment.attachment_id} sx={{ mb: 2 }}>
                                    <Card
                                      sx={{ position: 'relative', overflow: 'hidden', cursor: 'pointer' }}
                                      onClick={() => {
                                        setOpenLightbox(true);
                                        setSelectedImage(images.indexOf(attachment));
                                      }}
                                    >
                                      {renderCardDownloadButton(attachment, 'top-left')}
                                      <CardMedia
                                        component="img"
                                        height="140"
                                        image={attachment.url}
                                        alt={attachment.client_name}
                                      />
                                    </Card>
                                  </Grid>
                                ))}
                              </Grid>
                            )}

                            <TablePagination
                              rowsPerPageOptions={[3, 6, 9]}
                              component="div"
                              count={images.length}
                              rowsPerPage={imageRowsPerPage}
                              page={imagePage}
                              onPageChange={(event, newPage) => setImagePage(newPage)}
                              onRowsPerPageChange={(event) => {
                                setImageRowsPerPage(parseInt(event.target.value, 10));
                                setImagePage(0);
                              }}
                            />
                            </>
                        )}

                        {/* PDFs Section */}
                        {pdfs.length > 0 && (
                          <>
                            <Grid container spacing={2} sx={{ mt: 3, display: 'flex', flexDirection: 'row', alignItems: 'flex-start' }}>
                              <Grid item xs={12}>
                                <Typography variant="h6">PDFs</Typography>
                              </Grid>
                              {pdfs.slice(pdfPage * pdfRowsPerPage, pdfPage * pdfRowsPerPage + pdfRowsPerPage).map((attachment) => (
                                <Grid item xs={12} sm={4} md={4} key={attachment.attachment_id} sx={{ mb: 2 }}>
                                  <Card
                                    sx={{ cursor: 'pointer' }}
                                    onClick={() => openAttachmentPreview(attachment)}
                                  >
                                    <Box sx={{ position: 'relative', overflow: 'hidden' }}>
                                      {renderCardDownloadButton(attachment, 'top-left')}
                                      <Box
                                        sx={{
                                          width: '100%',
                                          height: 140,
                                          bgcolor: 'background.neutral',
                                        }}
                                      />
                                      <IconButton
                                        sx={{
                                          position: 'absolute',
                                          top: 8,
                                          right: 8,
                                          color: 'white',
                                          backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                          '&:hover': {
                                            backgroundColor: 'rgba(0, 0, 0, 0.7)',
                                          },
                                        }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          openAttachmentPreview(attachment);
                                        }}
                                      >
                                        <FullscreenIcon />
                                      </IconButton>
                                    </Box>
                                  </Card>
                                </Grid>
                              ))}
                            </Grid>
                            <TablePagination
                              rowsPerPageOptions={[3, 6, 9]}
                              component="div"
                              count={pdfs.length}
                              rowsPerPage={pdfRowsPerPage}
                              page={pdfPage}
                              onPageChange={(event, newPage) => setPdfPage(newPage)}
                              onRowsPerPageChange={(event) => {
                                setPdfRowsPerPage(parseInt(event.target.value, 10));
                                setPdfPage(0);
                              }}
                            />
                          </>
                        )}

                        {renderAttachmentSection('Documents', taxExemptDocuments)}

                      </Stack>
                    </>)}


                <Divider sx={{ mb: 3, paddingBottom: '10px' }} />

                {/* About Section */}
                {!isDriver && userType !==3 && (
                <TextField
                  {...getFieldProps('about')}
                  fullWidth
                  disabled={
                    isTeam ? (userData.internal_note ? true : false) : false
                  }
                  multiline
                  minRows={4}
                  maxRows={4}
                  value={values.about || ''}
                  onChange={(e) => {
                    const noteValue = e.target.value;
                    setFieldValue('about', noteValue);
                    // Track if note has content for submission
                    setInternalNote(noteValue && noteValue.trim().length > 0);
                  }}
                  label="Internal note"
                  placeholder="Write a note here"
                  inputProps={{
                    maxLength: 100
                  }}
                  error={Boolean(touched.about && errors.about)}
                  helperText={
                    touched.about && errors.about 
                      ? errors.about 
                      : `${(values.about || '').length}/100 characters`
                  }
                />
                )}

                {/* Save and Cancel Buttons */}
                {internalNoteState && (
                  <Box
                    sx={{
                      mt: 3,
                      display: 'flex',
                      justifyContent: 'flex-end',
                      paddingBottom: 2,
                      marginBottom: 2,
                    }}
                  >
                    {isTeam && !userData.internal_note && (
                      <LoadingButton
                        type="submit"
                        variant="contained"
                        loading={isSubmitting}
                      >
                        Add Internal Note
                      </LoadingButton>
                    )}
                    {isClient && !clientDetails.internal_note && (
                       <LoadingButton
                       type="submit"
                       variant="contained"
                       loading={isSubmitting}
                     >
                       Add Internal Note
                     </LoadingButton>
                      // <Button variant="contained">Add Internal Note</Button>
                    )}

                    {isTeam && !userData?.internal_note && (
                      <Button
                        variant="outlined"
                        type="submit"
                        onClick={()=>handleResetInternalNote(formik)}
                        sx={{ marginLeft: '10px' }}
                      >
                        Clear
                      </Button>
                    )}
                    {isClient && !clientDetails?.internal_note &&(
                      <Button 
                      variant="contained"
                      type="submit"
                      onClick={handleResetInternalNote}
                       sx={{ marginLeft: '10px' }}>
                        Clear
                      </Button>
                    )}
                  </Box>
                )}
              </Stack>
              <LightboxModalTaxType
                images={images.map(attachment => ({ src: attachment.url }))}
                photoIndex={selectedImage}
                setPhotoIndex={setSelectedImage}
                isOpen={openLightbox}
                onClose={() => setOpenLightbox(false)}
                showDownload={canDownloadFiles}
                onDownload={() => {
                  const att = images[selectedImage];
                  if (!att?.url) return;
                  downloadImage(
                    att.url,
                    att.client_name,
                    selectedImage,
                    () => enqueueSnackbar('File downloaded successfully', { variant: 'success' }),
                    (err) => {
                      if (err?.message === 'DOWNLOAD_FALLBACK_TAB') {
                        enqueueSnackbar(
                          'File opened in a new tab. Use your browser’s save option if it did not download.',
                          { variant: 'warning' }
                        );
                        return;
                      }
                      enqueueSnackbar('Failed to download file', { variant: 'error' });
                    }
                  );
                }}
              />

              <AttachmentPreviewDialog
                open={attachmentPreviewOpen}
                onClose={() => {
                  setAttachmentPreviewOpen(false);
                  setPreviewAttachment(null);
                }}
                fileUrl={previewAttachment?.url}
                file={attachmentToDownloadFile(previewAttachment)}
                isClient={viewerIsClient}
                userType={userType}
                pdfLoading={previewPdfLoading}
                setPdfLoading={setPreviewPdfLoading}
                useOfficeViewer={previewUseOfficeViewer}
                setUseOfficeViewer={setPreviewUseOfficeViewer}
              />

              {/* <Divider sx={{ mb: 3, paddingBottom: '30px' }} /> */}

              {/* Second Section */}
              {/* {isClient && (
                <>
                  <Box>
                    <Typography variant="h6">Groups</Typography>
                    <Typography variant="body1" sx={{ color: 'primary.main' }}>
                      Traffic Solutions, Install
                    </Typography>
                  </Box>
                  <Divider sx={{ mb: 3, paddingBottom: '30px' }} />
                </>
              )} */}

              {/* Third Section */}
              {/* {isClient && (
                <Box
                  sx={{
                    mt: 3,
                    display: 'flex',
                    paddingBottom: 2,
                    marginBottom: 2,
                    alignItems: 'center',
                  }}
                >
                  {isReviewFormOpen ? (
                    <ExpandLess
                      onClick={() => {
                        setIsReviewFormOpen(false)
                      }}
                      sx={{ cursor: 'pointer', color: 'primary.main' }}
                    />
                  ) : (
                    <ExpandMore
                      onClick={() => {
                        setIsReviewFormOpen(true)
                      }}
                      sx={{ cursor: 'pointer', color: 'primary.main' }}
                    />
                  )}
                  <Typography
                    variant="body1"
                    onClick={() => {
                      setIsReviewFormOpen((prev) => !prev)
                    }}
                    sx={{ cursor: 'pointer', color: 'primary.main' }}
                  >
                    Reviews
                  </Typography>
                </Box>
              )} */}
              {/* {isReviewFormOpen && (
                // The form that appears when Reviews is clicked
                <Grid item xs={12} md={12}>
                  <Card sx={{ p: 3 }}>
                    <Stack spacing={3}>
                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={{ xs: 3, sm: 2 }}
                      >
                        <Grid item xs={3}>
                          {[100].map((size, index) => (
                            <Avatar
                              key={size}
                              alt={ isClient ?clientDetails?.name:values.displayName}
                              src={ isClient ?clientDetails?.profile_pic:values.photoURL}
                              // alt="Travis Howard"
                              // src={`/static/mock-images/avatars/avatar_3.jpg`}
                              sx={{ width: size, height: size }}
                            />
                          ))}
                        </Grid>

                        <TextField
                          fullWidth
                          label="Write your review here"
                          multiline
                          value={clientDetails?.review_comment}
                          rows={4} 
                          // placeholder="Write your review here"
                        />
                      </Stack>
                      <Stack
                        direction={{ xs: 'column', sm: 'row' }}
                        spacing={{ xs: 3, sm: 2 }}
                      >
                      </Stack>
                      <Grid container spacing={2}>
                        <Grid item xs={12} sm={3}>
                          <div>
                            <LabelStyle>Quality</LabelStyle>
                            <Rating
                              name="Quality"
                              value={clientDetails?.quality_rating}
                            />
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <div>
                            <LabelStyle>Delivery</LabelStyle>
                            <Rating
                              name="Delivery"
                              value={clientDetails?.delivery_rating}
                            />
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <div>
                            <LabelStyle>Value for money</LabelStyle>
                            <Rating
                              name="Value-for-money"
                              value={clientDetails?.value_for_money_rating}
                             
                            />
                          </div>
                        </Grid>
                        <Grid item xs={12} sm={2}>
                          <div>
                            <LabelStyle>Recommended</LabelStyle>
                            <div
                              style={{ display: 'flex', alignItems: 'center' }}
                            >
                              <IconButton
                                aria-label="like"
                                
                                style={{ color: clientDetails.recommended ==1 ? 'green' : 'inherit' }}
                              >
                                <ThumbUpIcon />
                              </IconButton>
                              <IconButton
                                aria-label="dislike"
                                
                                style={{ color:clientDetails.recommended == 0  ? 'red' : 'inherit' }}
                              >
                                <ThumbDownIcon />
                              </IconButton>
                            </div>
                          </div>
                        </Grid>
                      </Grid>
                    </Stack>
                  </Card>
                </Grid>
              )} */}
            </Card>
          </Grid>
        </Grid>
      </Form>
    </FormikProvider>
  )
}
